import * as actionTypes from "./../../Constants/clients/clientActionTypes";
import API from "./../../Constants/clients/API";
import * as clientServices from "../../services/clients/index";
import mapClientDetailsToLookup from "../../Common/Utility/mapClientDetailsToLookup ";

export const clients = (clientData, showInfoBanner) => ({
    type: actionTypes.FETCH_ALL_CLIENTS,
    payload: { clients: clientData, showInfoBanner: showInfoBanner }
})

export const clientTypes = (clientType) => ({
    type: actionTypes.FETCH_CLIENT_TYPES,
    payload: { clientTypes: clientType }
})

export const generationTypes = (generationType) => ({
    type: actionTypes.FETCH_GENERATION_TYPES,
    payload: { generationTypes: generationType }
})

export const locations = (location) => ({
    type: actionTypes.FETCH_LOCATIONS,
    payload: { locations: location }
})

export const primaryTaskTypes = (taskType) => ({
    type: actionTypes.FETCH_TASK_TYPES,
    payload: { primaryTaskTypes: taskType }
})
export const clientGroups = (group) => ({
    type: actionTypes.FETCH_GROUPS,
    payload: { clientGroups: group }
})
export const clientDataById = (clientDataById) => ({
    type: actionTypes.GET_CLIENTS_BY_ID,
    payload: { clientDataById: clientDataById }
})

export const firmSettings = (firmSettings) => ({
    type: actionTypes.GET_FIRM_SETTINGS,
    payload: { firmSettings: firmSettings }
})

export function fetchAllClients(firmId, lookup, branchId, isGlobalUser, clientId, searchCriteria) {
    return async dispatch => {
        const clientData = await clientServices.req.getAllClients(API.getAllClients, firmId, clientId, searchCriteria);
        if (clientData.clients == null)
            clientData.clients = [];

        const clientDataFiltered = isGlobalUser == "N" ? clientData.clients.filter(x => x.branchId == branchId) : clientData.clients;
        let mappedData = mapClientDetailsToLookup(lookup, clientDataFiltered);

        var showInfoBanner = searchCriteria == null || !(searchCriteria.status.length > 0 || searchCriteria.location > 0 || searchCriteria.clientType > 0 ||
            searchCriteria.primaryTaskType > 0 || searchCriteria.searchText.length > 0);
        if (parseInt(clientId == null ? 0 : clientId) > 0)
            showInfoBanner = false;

        return dispatch(clients(mappedData, showInfoBanner && mappedData.length < clientData.totalClientsCount));
    };
}

export function fetchClientTypeLookUp() {
    return async dispatch => {
        const request = await clientServices.req.getClientTypesLookUp(API.getClientTypesLookUp)
        return dispatch(clientTypes(request))

    };
}
export function fetchGenerationTypeLookUp() {
    return async dispatch => {
        const request = await clientServices.req.getGenerationTypesLookUp(API.getGenerationTypesLookUp)
        return dispatch(generationTypes(request))

    };
}
export function fetchLocationLookUp(firmId) {
    return async dispatch => {
        const request = await clientServices.req.getLocationLookUp(API.getLocationLookUp, firmId)
        return dispatch(locations(request))

    };
}
export function fetchTaskTypeLookUp(firmId) {
    return async dispatch => {
        const request = await clientServices.req.getTaskTypeLookUp(API.getTaskTypeLookUp, firmId)
        return dispatch(primaryTaskTypes(request))

    };
}

export function fetchGroupLookUp(firmId) {
    return async dispatch => {
        const request = await clientServices.req.getGroupLookUp(API.getGroupLookUp, firmId)
        return dispatch(clientGroups(request))

    };
}
export function fetchClientById() {
    return async dispatch => {
        const request = await clientServices.req.getClientById(API.getClientById)
        return dispatch(clientDataById(request))

    };
}
export function fetchFirmSettings(firmId) {
    return async dispatch => {
        const request = await clientServices.req.getFirmSettings(API.getFirmSettings, firmId,)
        return dispatch(firmSettings(request))

    };
}
//CLEAR FILTERS ACTION
export function clearAllFilters(isClearFilters, allClients) {
    allClients = allClients.map((clients) => {
        clients.selected = false;
        return clients;
    });

    return dispatch => {
        return dispatch({
            payload: { isClearFilters, allClients },
            type: actionTypes.CLEAR_ALL_FILTERS
        });
    };
}

// GET VISIBLE ROWS COUNT
export function getRowsCountAfterFilter(rowsCount) {
    return dispatch =>
        dispatch({
            payload: { rowsCount },
            type: actionTypes.ROWS_COUNT_AFTER_FILTER
        });
}

//DISCARD CHANGES YES
export function discardChanges() {
    return dispatch =>
        dispatch({
            type: actionTypes.DISCARD_CHANGES_CLIENT
        });
}

//ADD NEW CLIENT
export function addNewClient(isAddNewClient) {
    return dispatch =>
        dispatch({
            payload: { isAddNewClient },
            type: actionTypes.ADD_NEW_CLIENT
        });
}

// GET SELECTED USERS ACTION
export function selectedClients(selectedClientsIds) {

    return dispatch =>
        dispatch({
            payload: { selectedClientsIds },
            type: actionTypes.GET_SELECTED_CLIENTS
        });
}
//UNLINK CLIENTS
export function unlinkClients(clientId) {
    return async dispatch => {
        const unlinkRequest = await clientServices.req.unlinkClients(API.unlinkClients, clientId,)
        return dispatch({
            type: actionTypes.UNLINK_CLIENTS,
            payload: { unlinkRequest }
        });

    };
}

export function staffAssignmentLookUp(firmId, clientId) {
    return async dispatch => {
        const staffAssignmentDetails = await clientServices.req.staffAssignmentLookUp(API.getStaffAssignmentLookUp, firmId, clientId)
        return dispatch({
            type: actionTypes.STAFF_ASSIGNMENT_LOOK_UP,
            payload: { staffAssignmentDetails }
        });

    };
}

export function searchUserLookUp(firmId, branchId, roleId) {
    return async dispatch => {
        const searchStaffDetails = await clientServices.req.searchUserLookUp(API.getSearchUserDetails, firmId, branchId, roleId)
        return dispatch({
            type: actionTypes.SEARCH_USER_LOOK_UP,
            payload: { searchStaffDetails }
        });

    };
}


